export default [
  // {
  //   path: '/property/lists',
  //   name: 'property-lists',
  //   component: () => import('@/views/properties/property-list/PropertyLists.vue'),
  //   meta: {
  //     resource: 'Property',
  //     action: 'read',
  //   },
  // },
  {
    path: '/property/add',
    name: 'property-create',
    component: () => import('@/views/properties/property-form/PropertyForm.vue'),
    meta: {
      resource: 'Property',
      action: 'create',
    },
  },
  {
    path: '/property/add/:ownerId',
    name: 'property-owner-create',
    component: () => import('@/views/properties/property-form/PropertyForm.vue'),
    meta: {
      resource: 'Property',
      action: 'create',
    },
  },
  {
    path: '/property/edit/:id',
    name: 'property-edit',
    component: () => import('@/views/properties/property-form/PropertyForm.vue'),
    meta: {
      resource: 'Property',
      action: 'update',
    },
  },
  {
    path: '/property/upload/:id',
    name: 'property-upload',
    component: () => import('@/views/properties/property-upload/propertyUpload.vue'),
    meta: {
      resource: 'Property',
      action: 'update',
    },
  },
  {
    path: '/property/tax/:id',
    name: 'property-tax',
    component: () => import('@/views/properties/property-tax/PropertyTax.vue'),
    meta: {
      resource: 'Property',
      action: 'update',
    },
  },
  {
    path: '/property/test',
    name: 'property-test',
    component: () => import('@/views/properties/property-test.vue'),
  },
  {
    path: '/property/request/lists',
    name: 'property-request-lists',
    component: () => import('@/views/properties/property-list/RequestList.vue'),
    meta: {
      resource: 'Property',
      action: 'read',
    },
  },

  //v2
  {
    path: '/property/lists',
    name: 'property-lists',
    component: () => import('@/views/properties/property-list-v2/PropertyList.vue'),
    meta: {
      resource: 'Property',
      action: 'read',
    },
  },
  {
    // ไล่ดู place ที่ซ้ำกัน (ข้อมูลจาก place_lang - for_import.csv เฉพาะแถวที่มี place_dup)
    path: '/property/duplicate',
    name: 'property-duplicate',
    component: () => import('@/views/properties/property-duplicate/PropertyDuplicate.vue'),
    meta: {
      resource: 'Property',
      action: 'read',
    },
  },
]
  